import styled from 'styled-components';
import {Button} from "@mui/material";

export const AdminMenuWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    background: inherit;
`;

export const AdminButton = styled(Button)<{ $active: boolean; $isOpen: boolean }>`
    display: flex;
    align-items: center;
    justify-content: ${({ $isOpen }) => $isOpen ? 'flex-start' : 'center'};
    text-align: left;

    height: 40px;
    width: ${({ $isOpen }) => $isOpen ? '100%' : '40px'};
    min-width: unset;
    padding: ${({ $isOpen }) => $isOpen ? '8px 12px' : '0'};

    gap: ${({ $isOpen }) => $isOpen ? '6px' : '0'};
    cursor: pointer;
    
    background: ${({ $active, theme }) =>
                        $active ? theme.palette.primary.main : 'transparent'};
    color: ${({ $active, theme }) =>
                        $active ? theme.palette.primary.contrastText : theme.palette.primary.main};
    font-family: ${({ theme }) => theme.typography.fontFamily};
    transition: background 0.3s;

    &:hover {
        background: ${({ $active, theme }) =>
                $active ? theme.palette.primary.dark : theme.palette.action.hover};    
    }

    svg, img {
        display: block;
        width: 24px;
        height: 24px;
        flex-shrink: 0;
        margin-right: ${({ $isOpen }) => $isOpen ? '6px' : '0'};
        color: ${({ $active, theme }) =>
                $active ? theme.palette.primary.contrastText : theme.palette.primary.main};
    }
    
    span {
        display: ${({ $isOpen }) => $isOpen ? 'inline' : 'none'};
        color: ${({ $active, theme }) =>
                $active ? theme.palette.primary.contrastText : theme.palette.primary.main};
        line-height: 20px;
        font-size: ${({ theme }) => theme.typography.body1.fontSize};
        text-overflow: ellipsis;
        white-space: nowrap;
        letter-spacing: ${({ theme }) => theme.typography.body1.letterSpacing};
    }
`;

export const Arrow = styled.div<{ $active: boolean; $isExpanded: boolean; $isOpen: boolean }>`
    width: 8px;
    height: 8px;
    border-left: 3px solid;
    border-bottom: 3px solid;
    
    border-color: ${({ $active, theme }) =>
            $active ? theme.palette.primary.contrastText : theme.palette.primary.main};
    
    
    transform: ${({$isExpanded}) => ($isExpanded ? "rotate(135deg)" : "rotate(-45deg)")};
    transition: transform 0.3s ease-in-out;
    
    ${({$isOpen}) => !$isOpen && "display: none;"};
    
    margin-left: auto;
    margin-right: 7px;
`;

export const DropdownMenu = styled.div<{ $open: boolean; $isOpen: boolean }>`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 8px;
    overflow: hidden;
    max-height: ${({$open}) => ($open ? "400px" : "0")};
    opacity: ${({$open}) => ($open ? "1" : "0")};
    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
    ${({$isOpen}) => !$isOpen && "align-items: center; width: 50px;"}
    padding-left: ${({$isOpen}) => $isOpen ? "12px" : "0"};
`;

export const DropdownItem = styled.button<{ $active: boolean; $isOpen: boolean }>`
    display: flex;
    align-items: center;
    gap: ${({$isOpen}) => ($isOpen ? "12px" : "0")};

    justify-content: ${({$isOpen}) => ($isOpen ? "flex-start" : "center")};
    width: ${({$isOpen}) => ($isOpen ? "100%" : "50px")};
    padding: ${({$isOpen}) => ($isOpen ? "5px 12px" : "6px")};
    
    border-radius: 20px;
    border: none;
    
    cursor: pointer;
    pointer-events: ${({$active}) => ($active ? "none" : "auto")};

    background: ${({ $active, theme }) =>
            $active ? theme.palette.primary.main : 'transparent'};

    color: ${({ $active, theme }) =>
            $active ? theme.palette.primary.contrastText : theme.palette.primary.main};    
    
    transition: all 200ms ease;

    &:hover {
        background: ${({ $active, theme }) =>
                $active ? theme.palette.primary.dark : theme.palette.action.hover};
    }

    svg {
        width: 20px;
        height: 20px;
        flex-shrink: 0;
        
        ${({ $isOpen, $active, theme }) => !$isOpen && `
            width: 20px;
            height: 20px;
            border-radius: 999%;
            background: ${$active ? theme.palette.primary.main : 'transparent'};
            color: ${$active ? theme.palette.primary.contrastText : theme.palette.primary.main};
                
            &:hover {
                background: ${$active ? theme.palette.primary.dark : theme.palette.action.hover};
            }
        `}
    }
    
    span {
        display: ${({ $isOpen }) => $isOpen ? 'inline' : 'none'};
        color: ${({ $active, theme }) =>
                $active ? theme.palette.primary.contrastText : theme.palette.primary.main};
        line-height: 20px;
        font-size: ${({ theme }) => theme.typography.body2.fontSize};
        text-overflow: ellipsis;
        white-space: nowrap;
        letter-spacing: ${({ theme }) => theme.typography.body1.letterSpacing};
    }
`;